export { default as TabView } from "./TabView";
export { default as TabBar } from "./TabBar";
import "./styles.css";
